import './CenterBottom.css';

export const CenterBottom = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="center-bottom">
      {children}
    </div>
  )
}
